import { createSlice } from "@reduxjs/toolkit";
import { stateEnum } from "../constants/enum";

const { cut } = stateEnum;

let initialState = {
    detailParams: {},
    isNewEntry: false
};


const cutSlice = createSlice({
    name: cut,
    initialState,
    reducers: {
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload;
        },
        setDetailParams: (state, action) => {
            state.detailParams = action.payload
          },
        resetDetail: (state) => {
            state.detailParams = {};
            state.isNewEntry = true;
        },
    },
    
});


export const { setNewEntryMode,setDetailParams, resetDetail } = cutSlice.actions;
export default cutSlice.reducer;
